import React, { useEffect, useState, useCallback, useMemo } from 'react'

import dayjs from 'dayjs'

import BookingBox from '../../../components/BookingBox'
import CurrencySymbol from '../../../components/CurrencySymbol'
import { getProductMenuModel } from '../../../model/store'
import { formatJSON } from '../../../utils'
import { calculateBookingTimes as calculateBookingTimesRule } from '../../../utils/bookRule'
import { getMemberInfo } from '../../../utils/storage/store'


const DATE_FORMAT = 'YYYY-MM-DD'
const DEFAULT_ADVANCE_SECONDS = 0
const DEFAULT_BOOKING_TIMES = {
    dates: {},
    advanceSeconds: DEFAULT_ADVANCE_SECONDS
}

// 生成时间间隔为30分钟的时间点
const generateTimeSlots = (startTime, endTime) => {
    const slots = []
    const start = dayjs(startTime, 'HH:mm')
    const end = dayjs(endTime, 'HH:mm')

    let current = start
    while (current.isBefore(end) || current.isSame(end, 'minute')) {
        slots.push(current.format('HH:mm'))
        current = current.add(30, 'minute')
    }

    return slots
}

const BookForm = ({ item, callback, cartItems, merchantInfo }) => {
    const [productInfo, setProductInfo] = useState({})
    const [bookingTimes, setBookingTimes] = useState(DEFAULT_BOOKING_TIMES)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const calculateBookingTimes = useCallback((data) => {
        /*
         try {
             const { extendColumn } = data
             if (!extendColumn?.length) {
                 setBookingTimes(DEFAULT_BOOKING_TIMES)
                 return
             }
 
             const config = formatJSON(extendColumn)
             if (!Object.keys(config).length) {
                 setBookingTimes(DEFAULT_BOOKING_TIMES)
                 return
             }
 
             const currentDate = new Date()
             let bookingDate = currentDate
 
             
 
             // 计算预约日期
             if (config.endAdvanceDay > 0) {
                 bookingDate = dayjs(currentDate).add(config.endAdvanceDay, 'day').toDate()
             }
             // 计算可预约天数
             const bookingDays = Math.max(1, parseInt(config.beginAdvanceDay || 1))
 
             //生成预约日期
             let nDateArr = Array.from({ length: bookingDays }, (_, i) => {
                 const date = dayjs(bookingDate).add(i, 'day').format(DATE_FORMAT)
                 return date
             })
 
             const bookDateArr = []
             if (config.bookTimeType === 1 && config.bookDate && config.bookDate.length > 0) {
                 config.bookDate.split(',').forEach((date, index) => {
                     if (index < bookingDays) {
                         const dateObj = dayjs(date).toDate()
                         if (dateObj >= currentDate) {
                             bookDateArr.push(date)
                         }
                     }
                 })
                 if (bookDateArr.length > 0) {
                     nDateArr = bookDateArr
                 }
             }
             console.log(bookDateArr, '////====bookDateArr===')
 
             // 计算提前预约时间（秒）
             const advanceSeconds = config.endAdvanceHour > 0
                 ? Number(config.endAdvanceHour) * 60 * 60 * 1000
                 : DEFAULT_ADVANCE_SECONDS
 
             // BookTimeType 1原来默认时间类型，2新的时间类型
             const bookTimeType = config.bookTimeType || 1
 
             const dates = {}
 
             nDateArr.forEach(date => {
                 //const date = dayjs(bookingDate).add(i, 'day').format(DATE_FORMAT)
                 dates[date] = []
 
                 if (bookTimeType === 1) {// 1原来默认时间类型，2新的时间类型
                     if (config.selTimeType === 3) { //时间段 2//无需选择
                         const arr = config.bookTime?.split('-')
                         const start = new Date(`${dayjs(date).format(DATE_FORMAT)} ${arr[0]}`)
                         const end = new Date(`${dayjs(date).format(DATE_FORMAT)} ${arr[1]}`)
 
                         //生成时间间隔为30分钟的时间点
                         const availableTimes = generateTimeSlots(start, end).filter(time => {
                             const timeSlot = new Date(`${dayjs(date).format(DATE_FORMAT)} ${time}`)
                             return timeSlot - currentDate > advanceSeconds
                         })
 
                         dates[date] = availableTimes.map(time => ({ label: time, value: time }))
                     } else if (config.selTimeType === 2) { //无需选择
                         dates[date] = []
                     } else {
                         // 计算可用时间段
                         const availableTimes = config.bookTime?.split(',')
                             .filter(time => {
                                 const timeSlot = new Date(`${dayjs(date).format(DATE_FORMAT)} ${time}`)
                                 return timeSlot - currentDate > advanceSeconds
                             }) || []
                         dates[date] = availableTimes.map(time => ({ label: time, value: time }))
                     }
 
                 } else {
                     const bookTimeRange = config.bookTimeRange || {}
 
                     // 获取当前日期是周几
                     const dayOfWeek = dayjs(date).format('dddd')
                     const timeRanges = bookTimeRange[dayOfWeek] || []
 
                     // 生成所有可用时间点
                     const availableTimes = timeRanges.reduce((acc, range) => {
                         const timeSlots = generateTimeSlots(`${date} ${range.start}`, `${date} ${range.end}`)
                         return [...acc, ...timeSlots]
                     }, [])
 
                     // 过滤掉已经过去的时间
                     const filteredTimes = availableTimes.filter(time => {
                         const timeSlot = new Date(`${date} ${time}`)
                         return timeSlot - currentDate > advanceSeconds
                     })
 
                     dates[date] = filteredTimes.map(time => ({ label: time, value: time }))
                 }
             })
 
             setBookingTimes({
                 dates,
                 advanceSeconds
             })
         } catch (err) {
             console.error('计算预约时间出错:', err)
             setError('计算预约时间时发生错误')
             setBookingTimes(DEFAULT_BOOKING_TIMES)
         }
         //*/

        const obj = calculateBookingTimesRule(data)
        if (obj) {
            const { dates, advanceSeconds } = obj
            setBookingTimes({
                dates,
                advanceSeconds
            })
        } else {
            setBookingTimes(DEFAULT_BOOKING_TIMES)
        }

        console.log(obj, '////====obj===')
    }, [])

    useEffect(() => {
        const fetchProductInfo = async () => {
            setLoading(true)
            setError(null)
            try {
                // 需传 memberId，否则接口不返回权益套餐价 packagePrice
                const { memberId = '' } = getMemberInfo() || {}
                const res = await getProductMenuModel({ productId: item.productId, memberId })
                const {
                    quantity, specItem, attrArr, attrKeys, productExtraNameKey,
                    productExtraSpecName, specsKey, subAttrKeys, packagePrice, packageName
                } = item
                const nObj = {
                    ...res,
                    quantity: item.quantity,
                    specItem,
                    attrArr,
                    attrKeys,
                    productExtraNameKey,
                    productExtraSpecName,
                    specsKey,
                    subAttrKeys,
                    // 接口未带回时，保留上一页已带权益价的商品字段（直接 Place Order 常见）
                    packagePrice: (res.packagePrice != null && res.packagePrice !== '')
                        ? res.packagePrice
                        : packagePrice,
                    packageName: res.packageName || packageName,
                }
                setProductInfo(nObj)
                calculateBookingTimes(res)
            } catch (err) {
                console.error('Get product info failed:', err)
                setError('Get product info failed')
            } finally {
                setLoading(false)
            }
        }

        fetchProductInfo()
    }, [item.productId, calculateBookingTimes, item])

    const bookingContent = useMemo(() => (
        <div className='jm-flex'>
            <div className='jm-flex-item'>
                <div className='fs-16'>
                    <b>{item.name || item.productName}</b>
                </div>
                <div>{item.time}</div>
            </div>
            <div>
                <b className='p10 fs-16 jm-price'>
                    <CurrencySymbol currency={item.currencyCode || item.currency} />
                    {item.price}
                </b>
            </div>
        </div>
    ), [item.productName, item.time, item.currency, item.price, item.name, item.currencyCode])

    if (loading) {
        return <div className="book-form">Loading...</div>
    }

    if (error) {
        return <div className="book-form error">{error}</div>
    }

    if (Object.keys(productInfo).length === 0) {
        return <div className="book-form">No date</div>
    }

    return (
        <div className='book-form'>
            {Object.keys(productInfo).length > 0 && (
                <BookingBox
                    callback={callback}
                    productInfo={{ ...productInfo }}
                    products={cartItems}
                    dates={bookingTimes.dates}
                    merchantInfo={merchantInfo}
                >
                    {bookingContent}
                </BookingBox>
            )}
        </div>
    )
}

export default BookForm
